import React, { Component } from "react";
import mainshapeafterImage from '../../frontend/assets/img/shape/main-shape-after.png';

class Counter extends Component {
    componentDidMount() {
        this.counterUp('.counter-number', 10, 1000);
    }

    counterUp(selector, delay, duration) {
        const counters = document.querySelectorAll(selector);

        counters.forEach(counter => {
            const updateCount = () => {
                const target = +counter.getAttribute('data-target');
                const count = +counter.innerText;
                const increment = target / (duration / delay);

                if (count < target) {
                    counter.innerText = Math.ceil(count + increment);
                    setTimeout(updateCount, delay);
                } else {
                    counter.innerText = target;
                }
            };

            updateCount();
        });
    }

    render() {
        return (
            <div className="counter-section bg-smoke-blue space">
                <div className="container">
                    <div className="row text-center justify-content-center wow fadeInUp" data-wow-delay="0.1s">
                        <div className="col-xl-6 col-lg-7 col-md-8 col-sm-9">
                            <div className="title-area">
                                <h2 className="sec-title">Currently Operating In</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row gy-20 justify-content-between">
                        <div className="col-lg-auto col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="counter-item text-center">
                                <h2 className="counter-text h2">Surat</h2>
                                <span className="counter-number" data-target="500">0 +</span>
                                <p className="counter-text h4">Students</p>
                            </div>
                        </div>
                        <div className="col-lg-auto col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="counter-item text-center">
                                <h2 className="counter-text h2">Ahmedabad</h2>
                                <span className="counter-number" data-target="150">0</span>
                                <p className="counter-text h4">Students</p>
                            </div>
                        </div>
                        <div className="col-lg-auto col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="counter-item text-center">
                                <h2 className="counter-text h2">Mumbai</h2>
                                <span className="counter-number" data-target="500">0</span>
                                <p className="counter-text h4">Students</p>
                            </div>
                        </div>
                        <div className="col-lg-auto col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="counter-item text-center">
                                <h2 className="counter-text h2">Pune</h2>
                                <span className="counter-number" data-target="150">0 +</span>
                                <p className="counter-text h4">Students</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-after style-2"><img src={mainshapeafterImage} alt="shape" /></div>
            </div>
        );
    }
}

export default Counter;
